import { CSSObject } from '@chakra-ui/react';
import { RaceCardSchema } from './RaceCards.styles';

export const raceCardStyles: RaceCardSchema = {
  GridRaceCards: {
    my: '2',
    mb: '3',
    fontFamily: 'accent',
  },
  FlexCard: {
    my: '1',
    borderRadius: 'lg',
    bg: 'rgba(57, 57, 57)',
    boxShadow:
      '0px 0px 0px 1px rgba(255, 255, 255, 0.1) inset, 0px 2px 12px 0px rgba(0, 0, 0, 0.45)',
  },
  LinkCardHeader: {
    bg: 'transparent',
    color: 'beta.400',
  },
  TextCardHeading: {
    color: 'white',
    fontSize: 'sm',
    fontWeight: 'semibold',
    textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
  },
  TextRaceNumber: {
    bg: 'whiteAlpha.400',
    borderRadius: 'sm',
    color: 'rgba(255, 255, 255, 1)',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
    lineHeight: '4',
  },
  GridCardContent: {
    color: 'blackAlpha.400',
    fontSize: 'sm',
    p: '0',
  },
  BoxGridHeaderItem: {
    bg: 'blackAlpha.400',
    color: 'white',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    lineHeight: 'normal',
  },
  FlexGridRunnerItem: {
    bg: 'transparent',
    borderBottom: '1px dashed',
    borderBottomColor: 'blackAlpha.300',
    px: '2.5',
  },
  TextRunner: {
    fontSize: 'xs',
    color: 'white',
    fontWeight: 'bold',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
  },
  TextRunnerNumber: {
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    sx: {
      _last: {
        fontSize: '2xs',
        fontWeight: 'normal',
        pos: 'relative',
        top: '-2px',
      },
    },
  },
  TextScratched: {
    color: 'white',
  },
  LinkRaceDetails: {
    variant: 'secondary',
    bgGradient: 'linear(to-b, beta.200, beta.500)',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    color: 'alpha.500',
    border: '1px solid rgba(255, 255, 255, 0.11)',
    position: 'relative',
    m: '2',
    py: '2',
    borderRadius: 'md',
    fontFamily: 'accent',
    fontSize: 'xs',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    transition: 'all .2s ease-in-out',
    _hover: {
      opacity: 0.8,
    },
    _disabled: {
      opacity: 0.4,
      pointerEvents: 'none',
      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    },
  },
  buttonRaceCardOddsProps: {
    w: '100%',
    fontSize: '15px',
    variant: 'primary',
    h: '8',
  },
};

export const TextRunner: CSSObject = {
  color: 'white',
};

export const IconCardHeader: CSSObject = {
  color: 'beta.400',
  filter: [
    'drop-shadow(0px 0px 8px rgba(125, 253, 42, 0.7))',
    null,
    null,
    'drop-shadow(0px 0px 8px rgba(37, 254, 214, 0.6))',
  ],
};
